import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	error: {
		color: "#f44336",
		fontSize: "0.75rem",
		marginBottom: 0,
	},
}));

function ErrorInputFieldWrapper({ errorMessage, children, style }) {
	const { classes, cx } = useStyles();
	return (
		<div style={style || {}}>
			{children}
			<p className={classes.error}>{errorMessage}</p>
		</div>
	);
}
export default ErrorInputFieldWrapper;
